import { useNavigate } from 'react-router-dom';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { setCookie } from '@kaltura-ott/tvpil-shared';

import { ONE_YEAR } from 'consts';
import { useErrorScreenContext } from 'context/error/error';
import { CommonError } from 'context/error/types';
import { ApplicationError } from 'interface';
import routes from 'routesPaths';
import { sendApplicationErrorEvent } from 'services/analytics/applicationErrorEvent';
import { getLegacyAppPath } from 'utils';

import { useAppStore } from '../../../common/useAppStore';
import { useLoginStore } from '../../../common/useLoginStore';

export function useHandleMigrationError() {
  const navigate = useNavigate();
  const { appStore } = useAppStore();
  const loginStore = useLoginStore();
  const errorScreenContext = useErrorScreenContext();

  return (error: CommonError) => {
    const redirectUrl = loginStore.userMigrationUri;
    const legacyAppPath = getLegacyAppPath(appStore?.params?.dmsSetting?.endpoint);

    setCookie('migo2tv', 0, {
      domain: legacyAppPath,
      'max-age': ONE_YEAR,
    });

    sendApplicationErrorEvent({
      context: UIDAPresentationTypeEnum.login,
      message: error.message,
      additionalInfo: ApplicationError.SelectServices,
    });

    errorScreenContext.setError({
      error: {
        icon: 'banContent',
        titleId: `AppErrorReaction.errorHouseholdMigration.title`,
        titleDefault: 'You Can’t Use this Version Yet',
        messageId: `AppErrorReaction.errorHouseholdMigration.message`,
        messageDefault: 'We hope to let you in very soon',
      },
      goBackButton: {
        goBackLink: async () => {
          await loginStore.logoutUser();
          navigate(routes.home.path);
        },
        translationId: `AppErrorReaction.errorHouseholdMigration.logOut`,
        defaultMessage: 'Log Out',
      },
      onClear: error.onCancel,
      retryButton: {
        onRetry: async () => {
          if (redirectUrl) {
            await loginStore.logoutUser();
            if (window.location.origin === redirectUrl) {
              window.location.reload();
            } else {
              window.location.href = redirectUrl;
            }
            errorScreenContext.stopLoadingError();
          }
        },
        translationId: `AppErrorReaction.errorHouseholdMigration.goToO2`,
        defaultMessage: 'Go to O2TV App',
      },
      isErrorFromTvpil: true,
    });
  };
}
